export default "__VITE_ASSET__BeBO21fd__"